import React from 'react';

import './styles.scss';

const LandingPageHeader = ({
  title,
  subTitle,
  date = '',
  styleOverrides = {},
  badge = <></>,
}) => {
  return (
    <div className="landing-page-header" style={styleOverrides}>
      <div className="landing-page-data app-centered">
        {badge}
        <div className="landing-page-title">{title}</div>
        {date && <div className="landing-page-date">{date}</div>}
        {subTitle && <div className="landing-page-sub-title">{subTitle}</div>}
      </div>
    </div>
  );
};

export default LandingPageHeader;
